import { Component, input } from '@angular/core';

@Component({
  selector: 'app-trash',
  imports: [],
  templateUrl: './trash.html',
})
export class Trash {
  size = input("6");
}

